import { useQuery } from '@apollo/client/react'
import {
  PortalMyBusinessesDocument,
  type PortalMyBusinessesQuery,
} from '@/graphql/generated/graphql'

export type BusinessListItem = PortalMyBusinessesQuery['portalMyBusinesses']['items'][number]

export interface UseMyBusinessesArgs {
  take: number
  skip: number
  search?: string | null
  isActive?: boolean | null
}

export function useMyBusinesses({ take, skip, search, isActive }: UseMyBusinessesArgs) {
  const { data, loading, error, refetch } = useQuery(PortalMyBusinessesDocument, {
    variables: {
      take,
      skip,
      search: search?.trim() ? search.trim() : null,
      isActive: isActive ?? null,
    },
    // cache-first: al reentrar a la sección no se repite la petición; el botón
    // "Actualizar" hace refetch explícito y las mutaciones refrescan vía refetchQueries.
    fetchPolicy: 'cache-first',
    notifyOnNetworkStatusChange: true,
  })

  return {
    businesses: data?.portalMyBusinesses.items ?? [],
    totalItems: data?.portalMyBusinesses.totalItems ?? 0,
    loading,
    error,
    refetch,
  }
}
